/*! @pentacode/ui v0.1.0 */
import "./icon-DW8BBY5W.js";
import { t as e } from "./styledElement-DUAqv8gi.js";
import { t } from "./css-build-DcREbovZ.js";
import { t as n } from "./decorateMetadata-BXz2gmG4.js";
import { t as r } from "./decorate-C_HUHFGG.js";
import { LitElement as i, html as a, nothing as o } from "lit";
import { customElement as s, property as c, state as l } from "lit/decorators.js";
import { styleMap as u } from "lit/directives/style-map.js";
// \0lit-plugin:css-sheet:./src/elements/avatar/avatar.css.js
var d = t("ptc-ui-avatar,:host{--initials-color:var(--color-fg,#000c);--border-padding:.15em;background:var(--color-bg,#fff);border-radius:100%;width:-moz-fit-content;width:fit-content;display:block;position:relative}.wrapper{text-align:center;color:var(--shade-5);width:2.5em;height:2.5em;line-height:calc(2.5em - (var(--border-padding) * 2));padding:var(--border-padding);background:conic-gradient(var(--shade-5) 0deg 360deg);border-radius:100%;position:relative;overflow:hidden}.content{border-radius:var(--radius-round);background:var(--color-bg,#fff);justify-content:center;align-items:center;width:100%;height:100%;display:flex;position:relative;overflow:hidden}.initials{color:color-mix(in lab, var(--initials-color), transparent 30%);letter-spacing:-.05em;font-size:1.1em;display:flex}img{object-fit:cover;background:var(--color-bg,#fff);width:100%;height:100%;filter:var(--darkmode-filter-reversal);border-radius:100%;position:absolute;inset:0;overflow:hidden}.badge{background:var(--color-highlight,var(--orange));color:var(--color-bg,#fff);border-radius:100%;padding:.3em;font-size:.6em;font-weight:700;position:absolute;bottom:0;right:0}.badge.red{background:var(--color-negative,#e74c3c)}"), f = class extends e(i) {
	constructor(...e) {
		super(...e), this.positionColors = [], this._hideImage = !1, this.styles = d;
	}
	_sanitizeAvatarUrl(e) {
		if (!e) return null;
		if (e.startsWith("./") || e.startsWith("/")) return e;
		try {
			let t = new URL(e).protocol;
			return t === "http:" || t === "https:" || t === "data:" && e.toLowerCase().startsWith("data:image/") ? e : null;
		} catch {
			return null;
		}
	}
	_getGradient() {
		return this.positionColors.length === 0 ? null : `conic-gradient(${this.positionColors.map((e, t) => `${e} ${t * 360 / this.positionColors.length}deg ${(t + 1) * 360 / this.positionColors.length}deg`).join(", ")})`;
	}
	render() {
		if (!this.employee) return a`
                <div class="wrapper" title="Nicht Zugewiesen">
                    <div class="content">
                        <div class="initials">
                            <ptc-ui-icon name="icon.status.unassigned"></ptc-ui-icon>
                        </div>
                    </div>
                </div>
            `;
		let e = this._getGradient(), t = this.employee.avatar ? this._sanitizeAvatarUrl(this.employee.avatar) : null;
		return a`
            <div
                class="wrapper"
                style=${e ? u({ background: e }) : o}
                title=${`${this.employee.firstName} ${this.employee.lastName}`}
            >
                <div class="content">
                    ${!t || this._hideImage ? a`<div class="initials">
                              ${[this.employee.firstName, this.employee.lastName].filter(Boolean).map((e) => e.charAt(0).toUpperCase()).join("")}
                          </div>` : o}
                    ${t ? a`
                              <img
                                  src=${t}
                                  loading="lazy"
                                  ?hidden=${this._hideImage}
                                  @error=${() => this._hideImage = !0}
                                  @load=${() => this._hideImage = !1}
                              />
                          ` : o}
                </div>
            </div>

            ${this.employee.status === "retired" ? a`<div class="badge red"><ptc-ui-icon name="icon.status.employment-ended"></ptc-ui-icon></div>` : this.employee.status === "probation" ? a`<div class="badge"><ptc-ui-icon name="icon.status.probation-period"></ptc-ui-icon></div>` : o}
        `;
	}
};
r([c({ attribute: !1 }), n("design:type", Object)], f.prototype, "employee", void 0), r([c({ type: Array }), n("design:type", Array)], f.prototype, "positionColors", void 0), r([l(), n("design:type", Object)], f.prototype, "_hideImage", void 0), f = r([s("ptc-ui-avatar")], f);
var p = f;
export { p as n, f as t };

//# sourceMappingURL=avatar-Cxc8l1TA.js.map